module.exports = __webpack_public_path__ + "img/LearningPlan.7c5c2ae5.jpg";